import { Banner, screenMdMin, screenLgMin, addColorSet } from '@spotify-internal/encore-web';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import BlockSerializer from 'lib/sanity/ui/BlockSerializer';
import { Banner as BannerType } from 'lib/sanity/types';
import analytics from 'utils/client/analytics/analytics';

// The max widths here are chosen to match Masthead widths
const StyledBanner = styled(Banner)`
  max-width: 750px;
  margin: 0 auto;

  @media (min-width: ${screenMdMin}) {
    max-width: 970px;
  }

  @media (min-width: ${screenLgMin}) {
    max-width: 1170px;
  }

  p:first-child {
    margin: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

const BannerBackground = styled.div`
  width: 100%;
  background: var(--background-base);
`;

const trackBannerLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  const element = e.target as Element;
  if (element.tagName === 'A') {
    analytics.trackEvent({
      category: 'support_site_banner',
      action: 'click_banner_link',
      label: element.getAttribute('href') || undefined,
    });
  }
};

const trackBannerLoad = () => {
  analytics.trackEvent({
    category: 'support_site_banner',
    action: 'banner_loaded',
  });
};

const WarningBanner = ({ banner }: { banner?: BannerType }) => {
  useEffect(trackBannerLoad, [banner]);

  if (!banner) {
    return null;
  }

  // TODO: Add UBI through BlockSerializerUbiProvider
  return (
    <BannerBackground className={addColorSet('warning')}>
      <StyledBanner colorSet="warning" onClick={trackBannerLinkClick}>
        <BlockSerializer value={banner.content} />
        <p>{new Date(banner._updatedAt).toUTCString()}</p>
      </StyledBanner>
    </BannerBackground>
  );
};
export default WarningBanner;
